import { render, staticRenderFns } from "./examinationAdministration.vue?vue&type=template&id=43cd6f9a&scoped=true"
import script from "./examinationAdministration.vue?vue&type=script&lang=js"
export * from "./examinationAdministration.vue?vue&type=script&lang=js"
import style0 from "./examinationAdministration.vue?vue&type=style&index=0&id=43cd6f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd6f9a",
  null
  
)

export default component.exports